var map = {
	"./components/link-patient-form/link-patient-form.html": 862,
	"./components/profile-management/profile-management.html": 863,
	"./components/tabs/change-email/change-email.html": 864,
	"./components/tabs/change-password/change-password.html": 865,
	"./components/tabs/notification-management/notification-management.html": 866,
	"./components/tabs/personal-informations/personal-informations.html": 867,
	"./config/locales/en.json": 868,
	"./config/locales/fr_CA.json": 869
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 861;


//////////////////
// WEBPACK FOOTER
// ./profile \.(html|json|woff|woff2|ttf|eot|svg|gif|png)$
// module id = 861
// module chunks = 0